import Image from 'next/image';

import MediaWithAuthHeader from '@/components/mediaWithAuthHeader/mediaWithAuthHeader';
import { cpCreateImageListType, CpCreateVideoListType } from '@/types/cpCreateType';
import {
    CpImageType,
    CpVideoType,
    CpPornAlbumVideoList,
    CpPornAlbumInfoTrailerType
} from '@/types/cpType';
import { convertSecondsToTime } from '@/utils/timeConverter';

import DiamondIcon from './img/diamond.svg';
import LockIcon from './img/lock.svg';
import PlayIcon from './img/play.svg';
import ViewIcon from './img/view.svg';

import style from './cpMediaListCard.module.scss';

type CpInfoType = CpVideoType | CpImageType | CpPornAlbumVideoList | CpPornAlbumInfoTrailerType;
type CpCreateType = cpCreateImageListType | CpCreateVideoListType;

function CpMediaListCard({
    isVideo = false,
    isPorn = false,
    isTrailer = false,
    isCreate = false,
    mediaData,
    onClick,
    className,
    ...prop
}: {
    isVideo?: boolean; // 是否為影片
    isPorn?: boolean; // 是否為迷片
    isTrailer?: boolean; // 是否為預告片
    isCreate?: boolean; // 是否創作頁
    mediaData: CpInfoType | CpCreateType;
    onClick?: () => void;
    className?: string;
}) {
    const statusOption = ['審核中', '', '未過審'];

    const handleClick = () => {
        if (onClick) {
            onClick();
        }
    };
    return (
        <div className={`${style.cpMediaListCard} ${className}`} {...prop} onClick={handleClick}>
            {(mediaData as CpVideoType | CpImageType | CpPornAlbumVideoList).is_lock ? (
                <Image
                    alt=""
                    src={isVideo ? (mediaData as CpVideoType).cover : mediaData.url}
                    fill
                    sizes="100%"
                    style={{ objectFit: 'cover' }}
                    className={style.img}
                />
            ) : (
                <MediaWithAuthHeader
                    className={style.img}
                    src={isVideo ? (mediaData as CpVideoType).cover : mediaData.url}
                />
            )}

            {isVideo ? (
                <div className={style.videoBar}>
                    <div className={style.left}>
                        {isTrailer && <div className={style.trailer}>預告</div>}
                        {!isTrailer && isPorn && (
                            <div className={style.episode}>
                                {(mediaData as CpPornAlbumVideoList).episode}
                            </div>
                        )}
                    </div>

                    <div className={style.videoInfo}>
                        <PlayIcon />
                        {convertSecondsToTime((mediaData as CpVideoType).duration)}
                    </div>
                </div>
            ) : null}

            <div className={style.infoBar}>
                {isPorn ? (
                    <>
                        {isTrailer || (mediaData as CpPornAlbumVideoList)?.is_public ? (
                            <>
                                <div className={style.info}>
                                    {(mediaData as CpPornAlbumVideoList).is_new && (
                                        <div className={style.new}>New!</div>
                                    )}
                                </div>
                                <div className={style.info}>
                                    <ViewIcon />
                                    {mediaData.view_count}
                                </div>
                            </>
                        ) : (
                            <>
                                <div className={style.info} />
                                <div className={style.info}>
                                    <LockIcon />
                                    {mediaData.unlock_count}
                                </div>
                            </>
                        )}
                    </>
                ) : (
                    <>
                        {(mediaData as CpVideoType | CpImageType).diamond > 0 ? (
                            <>
                                <div className={style.info}>
                                    <DiamondIcon />
                                    {(mediaData as CpVideoType | CpImageType).diamond}
                                </div>
                                <div className={style.info}>
                                    <LockIcon />
                                    {mediaData.unlock_count}
                                </div>
                            </>
                        ) : (
                            <>
                                <div className={style.info} />
                                <div className={style.info}>
                                    <ViewIcon />
                                    {mediaData.view_count}
                                </div>
                            </>
                        )}
                    </>
                )}
            </div>

            {isCreate && (
                <div className={style.mediaStatus}>
                    {statusOption[(mediaData as CpCreateType).status]}
                </div>
            )}
        </div>
    );
}

export default CpMediaListCard;
